export default __webpack_public_path__ + "static/media/banner1.a2cc5902.png";